/**
 * AvailabilityFilter - Filter toggle for whether copies are free to use
 *
 * "Available" means owned across all printings minus copies committed to active decks.
 * Mutually exclusive chips; clicking the active chip clears the filter.
 */
import type { ReactElement } from 'react';

import FilterChip from '@/components/FilterChip/FilterChip';

export type AvailabilityFilterValue = 'all' | 'available' | 'unavailable';

export interface AvailabilityFilterProps {
  value: AvailabilityFilterValue;
  onChange: (value: AvailabilityFilterValue) => void;
  className?: string;
}

export default function AvailabilityFilter({ value, onChange, className }: AvailabilityFilterProps): ReactElement {
  const toggle = (next: Exclude<AvailabilityFilterValue, 'all'>) => onChange(value === next ? 'all' : next);

  return (
    <div className={className}>
      <div className="flex items-center gap-2">
        <FilterChip
          label="Available"
          title="Owned copies not committed to an active deck"
          isActive={value === 'available'}
          onClick={() => toggle('available')}
        />
        <FilterChip
          label="Not available"
          title="No spare copies — unowned or fully committed to active decks"
          isActive={value === 'unavailable'}
          onClick={() => toggle('unavailable')}
        />
      </div>
    </div>
  );
}
